import { LowPriorityOutlined } from "@mui/icons-material";

export const lowPriority = (props) => {
  return <LowPriorityOutlined {...props} />;
};
